import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode temporalmente deshabilitado para evitar warnings de findDOMNode de react-quill
// TODO: Re-habilitar cuando react-quill actualice su código para React 18
root.render(
  <App />
);
